function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { pure } from 'recompose';
import SvgIcon from "../../SvgIcon";

var SvgaAlarmClock = function SvgaAlarmClock(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Clock' : _ref$title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement(SvgIcon, _extends({
    title: title
  }, rest, {
    viewBox: "0 0 52 48"
  }), React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", {
    transform: "translate(1.000000, 1.000000)"
  }, React.createElement("path", {
    d: "M43.4493707,21.8175057 C43.4493707,22.2960026 43.062593,22.6827803 42.5840961,22.6827803 L39.1229977,22.6827803 C38.6445009,22.6827803 38.2577231,22.2960026 38.2577231,21.8175057 L38.2577231,18.3564073 C38.2577231,17.8779105 38.6445009,17.4911327 39.1229977,17.4911327 L42.5840961,17.4911327 C43.062593,17.4911327 43.4493707,17.8779105 43.4493707,18.3564073 L43.4493707,21.8175057 Z",
    fill: "#FFFFFF"
  }), React.createElement("path", {
    d: "M43.4493707,21.8175057 C43.4493707,22.2960026 43.062593,22.6827803 42.5840961,22.6827803 L39.1229977,22.6827803 C38.6445009,22.6827803 38.2577231,22.2960026 38.2577231,21.8175057 L38.2577231,18.3564073 C38.2577231,17.8779105 38.6445009,17.4911327 39.1229977,17.4911327 L42.5840961,17.4911327 C43.062593,17.4911327 43.4493707,17.8779105 43.4493707,18.3564073 L43.4493707,21.8175057 L43.4493707,21.8175057 Z",
    stroke: "#8C8C8C",
    strokeWidth: "1.05263158",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M39.9882723,20.0869565 C39.9882723,31.0785398 31.0785398,39.9882723 20.0869565,39.9882723 C9.09537328,39.9882723 0.185640732,31.0785398 0.185640732,20.0869565 C0.185640732,9.09537328 9.09537328,0.185640732 20.0869565,0.185640732 C31.0785398,0.185640732 39.9882723,9.09537328 39.9882723,20.0869565",
    fill: "#FFFFFF"
  }), React.createElement("path", {
    d: "M20.0869565,28.7397025 C15.3080449,28.7397025 11.4342105,24.8658681 11.4342105,20.0869565 C11.4342105,15.3080449 15.3080449,11.4342105 20.0869565,11.4342105 C24.8658681,11.4342105 28.7397025,15.3080449 28.7397025,20.0869565 C28.7397025,24.8658681 24.8658681,28.7397025 20.0869565,28.7397025 Z",
    fill: "#DDDDDD"
  }), React.createElement("path", {
    d: "M39.9882723,20.0869565 C39.9882723,31.0785398 31.0785398,39.9882723 20.0869565,39.9882723 C9.09537328,39.9882723 0.185640732,31.0785398 0.185640732,20.0869565 C0.185640732,9.09537328 9.09537328,0.185640732 20.0869565,0.185640732 C31.0785398,0.185640732 39.9882723,9.09537328 39.9882723,20.0869565 L39.9882723,20.0869565 Z",
    stroke: "#8C8C8C",
    strokeWidth: "1.05263158",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M20.0869565,20.0869565 L12.2994851,12.2994851",
    stroke: "#8C8C8C",
    strokeWidth: "1.05263158",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M20.0869565,20.0869565 L31.3355263,8.83838673",
    stroke: "#8C8C8C",
    strokeWidth: "1.05263158",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M22.6827803,20.0869565 C22.6827803,21.5198513 21.5198513,22.6827803 20.0869565,22.6827803 C18.6540618,22.6827803 17.4911327,21.5198513 17.4911327,20.0869565 C17.4911327,18.6540618 18.6540618,17.4911327 20.0869565,17.4911327 C21.5198513,17.4911327 22.6827803,18.6540618 22.6827803,20.0869565",
    fill: "#FFFFFF"
  }), React.createElement("path", {
    d: "M22.6827803,20.0869565 C22.6827803,21.5198513 21.5198513,22.6827803 20.0869565,22.6827803 C18.6540618,22.6827803 17.4911327,21.5198513 17.4911327,20.0869565 C17.4911327,18.6540618 18.6540618,17.4911327 20.0869565,17.4911327 C21.5198513,17.4911327 22.6827803,18.6540618 22.6827803,20.0869565 L22.6827803,20.0869565 Z",
    stroke: "#8C8C8C",
    strokeWidth: "1.05263158",
    strokeLinejoin: "round"
  }))));
};

SvgaAlarmClock = pure(SvgaAlarmClock);
SvgaAlarmClock.displayName = 'SvgaAlarmClock';
export default SvgaAlarmClock;